import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { TreeTableModule } from 'primeng/treetable';
import { WaterUsageTreeRow } from '../../../types/dtos/device.dto';
import {TranslateSafePipe} from '../../../shared/pipes/translation.pipe';

@Component({
  selector: 'app-water-usage-per-district',
  imports: [
    TreeTableModule,
    TranslateSafePipe,
  ],
  templateUrl: './water-usage-per-district.html',
  styleUrl: './water-usage-per-district.css',
})
export class WaterUsagePerDistrict {
  @Input()
  public waterUsageData: TreeNode<WaterUsageTreeRow>[] = [];

  @Output()
  public selectedDistrictChange: EventEmitter<string | null> = new EventEmitter<string | null>();

  public selectedDistrict: string | null = null;


  public onRowClick(rowData: WaterUsageTreeRow): void {
    if (rowData.type !== 'District') {
      return;
    }

    if (this.selectedDistrict === rowData.district) {
      this.selectedDistrict = null;
    } else {
      this.selectedDistrict = rowData.district;
    }

    this.selectedDistrictChange.emit(this.selectedDistrict);
  }
}
